import React, { useEffect, useState } from 'react';
import {
  Button,
  Collapse,
  Form,
  Image,
  Input,
  List,
  Modal,
  PageHeader,
  Space,
  Statistic,
  Typography,
} from 'antd';
import { getStorage } from '../../../lib/webStorage';
import { FormInstance } from 'antd/lib/form/hooks/useForm';
import { AdminUri } from '../../core/configs/services';
import { usePageState } from '../../core/hooks/usePageState';
import { AdminResponse } from '../../domain/models/adminResponse';
import adminRequest from '../../../config/adminRequest';
import SystemProvider, {
  TypeSystemSettingAll,
} from '../../domain/usdt-providers/systemProvider';
import { TwoFactoryProvider } from '../../../core/providers/twoFactoryProvider';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { DomainConstants } from '../../domain/domainConstants';

const { Text } = Typography;

const { Panel } = Collapse;

const initialSettingProperties: TypeSystemSettingAll = {
  systemId: '',
  systemName: '',
  creditNotifyUrl: '',
  payforNotifyUrl: '',
  depositMode: 1,
  merchantType: DomainConstants.merchantType.NORMAL,
  lang: '',
};

interface PageOp {
  tab?: string;
  panel: { [key: string]: string[] };
}

// eslint-disable-next-line
export default () => {
  const GoogleAuthQrcode = getStorage('uga');
  const settingForm = React.createRef<FormInstance>();
  const googleAuthValidateForm = React.createRef<FormInstance>();
  const resetPasswordForm = React.createRef<FormInstance>();
  const [settingProperties, setProperties] = useState<TypeSystemSettingAll>(
    initialSettingProperties,
  );
  const [saveLoading, setSaveLoading] = useState(false);
  const [googleAuthProperties, setGoogleAuthProperties] = useState({
    qrcode: GoogleAuthQrcode,
    isGoogleAuthEnabled: !!GoogleAuthQrcode,
    qrcodePlaceholder:
      'data:image/png;base64,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',
  });
  const pageOp = usePageState<PageOp>('PAGE_REMEMBER', {
    tab: '1',
    panel: {
      '1': ['1', '2'],
      '2': ['1', '2', '3'],
    },
  });
  const { t } = useTranslation();
  useEffect(() => {
    settingLoad();
    TwoFactoryProvider.generate().then((rs) => {
      setGoogleAuthProperties((s) => ({
        ...s,
        qrcode: rs.data?.qrcode ?? s.qrcode,
      }));
    });
  }, []);

  useEffect(() => {
    if (settingForm.current) {
      settingForm.current.setFieldsValue(settingProperties);
    }
    // eslint-disable-next-line
  }, [settingProperties, pageOp]);

  const settingLoad = () => {
    const systemId = getStorage('systemId');
    SystemProvider.getSystemVar(systemId).then((res) => {
      setProperties(res);
    });
  };
  const resetPasswordSave = () => {
    if (resetPasswordForm.current)
      resetPasswordForm.current.validateFields().then((values) => {
        if (resetPasswordForm.current) resetPasswordForm.current.resetFields();
        setSaveLoading(true);
        adminRequest
          .put<AdminResponse<any>>(AdminUri('admin/auth/reset/password'), {
            oldPassword: values.oldPassword,
            password: values.password,
            code: values.code ?? '',
          })
          .then((rs) => {
            if (rs.data.code !== '00') {
              Modal.error({
                content: rs.data.message,
                okText: t('common.confirm'),
              });
            } else {
              Modal.success({
                content: t('common.update_success'),
                okText: t('common.confirm'),
              });
            }
          })
          .finally(() => {
            setSaveLoading(false);
          });
      });
  };
  const googleAuthValidate = () => {
    if (googleAuthValidateForm.current)
      googleAuthValidateForm.current.validateFields().then((values) => {
        if (googleAuthValidateForm.current)
          googleAuthValidateForm.current.resetFields();
        setSaveLoading(true);
        TwoFactoryProvider.validate(values.token)
          .then((rs: any) => {
            Modal[rs.data ? 'success' : 'error']({
              title: t('common.two_factor_auth_result'),
              content: rs.data
                ? t('common.verify_success')
                : t('common.verify_fail'),
              okCancel: false,
            });
          })
          .finally(() => {
            setSaveLoading(false);
          });
      });
  };
  const panels = pageOp.get().panel ?? {};
  const headerFooter = (
    <>
      <Collapse
        style={{ marginTop: 30 }}
        defaultActiveKey={panels['1']}
        onChange={(val) => {
          pageOp.update((v) => ({
            ...v,
            panel: { ...v.panel, '1': Array.isArray(val) ? val : [val] },
          }));
        }}
      >
        <Panel header={i18next.t('common.change_password')} key={1}>
          <Form ref={resetPasswordForm} layout="vertical" autoComplete="off">
            <Form.Item
              label={i18next.t('common.old_password')}
              name="oldPassword"
              rules={[
                {
                  required: true,
                  message: t('common.error_message.plz_enter_current_pwd'),
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label={i18next.t('common.new_password')}
              name="password"
              rules={[
                {
                  required: true,
                  message: t('common.error_message.plz_enter_new_pwd'),
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label={i18next.t('common.confirm_new_password')}
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: t('common.error_message.plz_enter_new_pwd_again'),
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      t('common.err_message.not_match_the_new_pwd'),
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            {/*<Form.Item label="二階段驗證碼" name="code" rules={[{ required: true, pattern: /\d{6}/, message: '請輸入正確的驗證碼' }]}>*/}
            {/*    <Input />*/}
            {/*</Form.Item>*/}
            <Form.Item>
              <Button
                type="primary"
                onClick={resetPasswordSave}
                loading={saveLoading}
              >
                {i18next.t('common.save')}
              </Button>
            </Form.Item>
          </Form>
        </Panel>
        <Panel header={i18next.t('common.two_factor_auth_setting')} key={2}>
          {googleAuthProperties.isGoogleAuthEnabled ? (
            <List>
              <List.Item>
                <Space>
                  <Text>{i18next.t('common.status')}：</Text>
                  <Text strong>{i18next.t('common.activated')}</Text>
                </Space>
              </List.Item>
              <List.Item>
                <Space direction="vertical">
                  <Space>
                    <Image
                      preview={false}
                      src={googleAuthProperties.qrcodePlaceholder}
                      width={36}
                    />
                    <Text type="secondary">
                      {i18next.t('common.qrCode_auth_description')}
                    </Text>
                  </Space>
                  <Image src={googleAuthProperties.qrcode} />
                  <Form
                    ref={googleAuthValidateForm}
                    layout="inline"
                    autoComplete="off"
                  >
                    <Form.Item
                      label={i18next.t('common.auth_code')}
                      name="token"
                      rules={[
                        {
                          required: true,
                          pattern: /\d{6}/,
                          message: t(
                            'common.error_message.plz_enter_correct_verify_code',
                          ),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        onClick={googleAuthValidate}
                        loading={saveLoading}
                      >
                        {i18next.t('common.confirm')}
                      </Button>
                    </Form.Item>
                  </Form>
                </Space>
              </List.Item>
            </List>
          ) : null}
        </Panel>
        <Panel header={i18next.t('payment.notify_url')} key={3}>
          {settingProperties.depositMode === 1 ? (
            <Statistic
              title={i18next.t('credit.direct_mode_callback_url')}
              valueRender={() => settingProperties.creditNotifyUrl}
            />
          ) : settingProperties.depositMode === 2 ? (
            <>
              <Statistic
                title={i18next.t(
                  'credit.booking_mode_mapping_success_callback_url',
                )}
                valueRender={() => settingProperties.creditNotifyUrl}
              />
              <Statistic
                title={i18next.t(
                  'credit.booking_mode_mapping_fail_callback_url',
                )}
                valueRender={() => settingProperties.creditNotifyUrl}
              />
            </>
          ) : settingProperties.depositMode === 3 ? (
            <Statistic
              title={i18next.t(
                'credit.polling_mode_mapping_success_callback_url',
              )}
              valueRender={() => settingProperties.creditNotifyUrl}
            />
          ) : settingProperties.depositMode === 4 ? (
            <Statistic
              title={i18next.t(
                'credit.polling_mode_mapping_success_callback_url',
              )}
              valueRender={() => settingProperties.creditNotifyUrl}
            />
          ) : (
            <></>
          )}
          <Statistic
            title={i18next.t('payfor.callback_url')}
            valueRender={() => settingProperties.payforNotifyUrl}
          />
        </Panel>
      </Collapse>
    </>
  );

  return (
    <>
      <PageHeader
        title={i18next.t('common.security_center')}
        footer={headerFooter}
      />
    </>
  );
};
